import { CmtsDashboardShell } from "@components/dashboard/index.js";
import type { CmtsDashboardVm } from "@cmts/view-models/dashboardViewModels.js";

export type CmtsDashboardsPageProps = {
  readonly dashboard?: CmtsDashboardVm | null | undefined;
  readonly drilldown?: unknown | undefined;
  readonly dashboardType?: string | undefined;
  readonly error?: unknown | undefined;
  readonly onOpenDrilldown?: ((path: string, id: string) => void) | undefined;
  readonly onDrilldown?: ((id: string) => void) | undefined;
};

export function CmtsDashboardsPage(props: CmtsDashboardsPageProps) {
  return <CmtsDashboardShell dashboard={props.dashboard as unknown as Record<string, unknown> | null | undefined} error={props.error} dashboardType={props.dashboardType ?? props.dashboard?.dashboardType ?? "management"} readOnly={props.dashboardType === "executive"} />;
}
